import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';


function GameDevelopment() {
  return (
    <>
      <SEO title="Game Development Services" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div
          className="slider-area slider-style-1 height-380 bg_image"
          data-black-overlay="1"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/GameDev.png)`
          }}>
        </div>
        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Game Development</h1>
            <p style={{ marginBottom: '3.5rem' }}>
              #1 GAME DEVELOPMENT AGENCY IN INDIA
            </p>
            <p style={{ marginBottom: '3.5rem' }}>
              We craft immersive, visually stunning, and performance-optimized games that deliver outstanding experiences across platforms. Whether it's mobile, web, or desktop — our game developers turn your ideas into reality using cutting-edge tools like Unity, Unreal Engine, and Godot.
            </p>

            <h3>Custom Game Development Services</h3>
            <p style={{ marginBottom: '3.5rem' }}>
              We offer full-cycle game development — from concept to deployment. Our team handles game design, coding, animation, testing, and monetization strategies with unmatched precision and creativity.
            </p>

            <h3>What We Offer:</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Mobile Game Development (Android & iOS)</li>
              <li>2D and 3D Game Design</li>
              <li>Unity & Unreal Engine Expertise</li>
              <li>Multiplayer & Online Game Integration</li>
              <li>AR/VR Game Development</li>
              <li>Gamification Solutions for Enterprises</li>
              <li>Blockchain & NFT Game Integration</li>
            </ul>

            <h3>Why Choose Our Game Studio?</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Dedicated team of game designers, artists, and developers</li>
              <li>Cross-platform performance optimization</li>
              <li>Scalable architecture for future expansions</li>
              <li>Real-time multiplayer expertise</li>
              <li>End-to-end support from planning to post-launch</li>
              <li>In-depth knowledge of monetization strategies (ads, IAPs)</li>
            </ul>

            <h3>Top Game Genres We Specialize In:</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Action & Adventure</li>
              <li>Strategy & Puzzle</li>
              <li>Casual Hyper-Casual Games</li>
              <li>RPG and Simulation</li>
              <li>Educational Games</li>
              <li>Fantasy Sports & Real Money Gaming</li>
            </ul>

            <h3>Rank Higher. Engage Deeper. Monetize Better.</h3>
            <p style={{ marginBottom: '3.5rem' }}>
              From intuitive UI/UX to robust backend architecture, every game we develop is engineered to rank on stores, retain users, and drive revenue. Let's build your next big hit.
            </p>
          </div>
          <div className='thirdy_container_for_services'>
            <img
              src={`${process.env.PUBLIC_URL}/images/bg/GameDev2.png`}
              alt="Game development services"
            />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  );
}

export default GameDevelopment;
